import styles from './index.less';

const NetworkErrorPage = ({ onRefresh }) => {
  return (
    <div className={styles.networkError}>
      <p className={styles.errorTitle}>出错了</p>
      <p className={styles.errorDesc}>请您检查网络状态</p>
      <button className={styles.action} onClick={onRefresh}>
        刷新
      </button>
    </div>
  );
};
export default NetworkErrorPage;
